import React, { useState, useMemo } from "react";
import { StoryCategoriesView } from "../stories/StoryCategoriesView";
import { CategoryStoriesView } from "../stories/CategoryStoriesView";

interface MemorialBiographyViewProps {
  memorialId: string;
  selectedCategory: { id: string; name: string } | null;
  onCategorySelect: (categoryId: string, categoryName: string) => void;
  onBackToCategories: () => void;
}

export const MemorialBiographyView = React.memo<MemorialBiographyViewProps>(({
  memorialId,
  selectedCategory,
  onCategorySelect,
  onBackToCategories
}) => {
  // Memoize the category components to prevent unnecessary rerenders
  const categoriesView = useMemo(() => (
    <StoryCategoriesView 
      memorialId={memorialId}
      onCategorySelect={onCategorySelect}
    />
  ), [memorialId, onCategorySelect]);

  const categoryStoriesView = useMemo(() => {
    if (!selectedCategory) return null;
    
    return (
      <CategoryStoriesView
        memorialId={memorialId}
        categoryId={selectedCategory.id}
        categoryName={selectedCategory.name}
        onBack={onBackToCategories}
      />
    );
  }, [memorialId, selectedCategory, onBackToCategories]);

  if (selectedCategory) {
    return categoryStoriesView;
  }

  return categoriesView;
});

MemorialBiographyView.displayName = 'MemorialBiographyView';